import React, { useEffect } from 'react';
import { useState } from 'react';

import './customSelect.scss';

interface ICateGoryList {
  id: number;
  name: string;
  order: number;
}

interface ICustomSelect {
  cateGoryList: ICateGoryList[];
  setCategory: (id: number | '') => void;
}

const CustomSelect = ({ cateGoryList, setCategory }: ICustomSelect) => {
  const [currentValue, setCurrentValue] = useState('ALL');
  const [isClick, setIsClick] = useState<boolean>(false);
  const [showOptions, setShowOptions] = useState(false);

  const handleOnChangeSelectValue = async (item: ICateGoryList) => {
    setCurrentValue(item.name);
    setCategory(item.id);
  };

  useEffect(() => {
    if (currentValue === 'ALL') {
      setCurrentValue('ALL');
      setCategory('');
    }
  }, [currentValue]);

  return (
    <>
      <div
        className="custom-select border flex jc-center"
        onClick={() => {
          setIsClick(!isClick);
          setShowOptions(!showOptions);
        }}
      >
        <div className={`selected flex jc-between ai-center`}>
          <div className="label">{currentValue}</div>

          <img className={`btn-up ${showOptions ? 'rotated' : ''}`} src="/seamansclub-news/assets/svg/drop-select-down.svg" alt="up" />
        </div>
        <div className="option_container" style={{ display: isClick ? 'block' : 'none' }}>
          {cateGoryList.map((item, index) => (
            <div key={index} className="option" onClick={() => handleOnChangeSelectValue(item)}>
              {item.name}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CustomSelect;
